import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { FormControl } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import routes from '../../../routesDefinitions/routes';
import { logIn } from '../../store/authSlice';

import './Login.scss';

const Login = ({ setIsAuthorized }) => {
  const { handleSubmit, register } = useForm();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleHistory = useCallback(
    async values => {
      const isLoggedIn = await dispatch(logIn(values));
      if (isLoggedIn === 'player') {
        setIsAuthorized(true);
        history.push('/player/inbox');
      } else if (isLoggedIn === 'assistant') {
        setIsAuthorized(true);
        history.push(routes.assistantDashboard.link);
      } else if (isLoggedIn) {
        setIsAuthorized(true);
        history.push(routes.players.link);
      }
    },
    [dispatch, history, setIsAuthorized],
  );

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Header */}
        <div className="login-card__header">
          <div className="login-card__icon">
            <i className="fas fa-lock" />
          </div>
          <h1>Welcome Back</h1>
          <p>Sign in to your PlaySport USA account</p>
        </div>

        {/* Google Login */}
        <div className="login-card__body">
          <button
            className="login-google-btn"
            type="button"
            onClick={e => {
              e.preventDefault();
              window.location.href =
                `${process.env.REACT_APP_API_URL || 'http://localhost:8080/api'}/users/auth/google`;
            }}
          >
            <svg viewBox="0 0 24 24" width="18" height="18">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>

          <div className="login-divider">
            <span>or sign in with email</span>
          </div>

          {/* Email Form */}
          <form className="login-form" onSubmit={handleSubmit(handleHistory)}>
            <div className="login-field">
              <label htmlFor="login-email">Email address</label>
              <div className="login-input-wrap">
                <i className="fas fa-envelope" />
                <FormControl
                  ref={register}
                  name="email"
                  id="login-email"
                  placeholder="you@university.edu"
                  required=""
                />
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="login-password">Password</label>
              <div className="login-input-wrap">
                <i className="fas fa-key" />
                <FormControl
                  ref={register}
                  name="password"
                  id="login-password"
                  placeholder="••••••••"
                  required=""
                  type="password"
                />
              </div>
            </div>

            <div className="login-forgot">
              <a href="/reset-password">Forgot password?</a>
            </div>

            <button className="login-submit-btn" type="submit">
              Sign In
            </button>
          </form>

          {/* Sign Up Link */}
          <div className="login-signup">
            <span>Don&apos;t have an account?</span>
            <button
              type="button"
              className="login-signup-link"
              onClick={() => history.push('/create-account')}
            >
              Create Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
